<template>
  <div class="rwa_kline_div">

    <div class="rwa_kline_page_01">
      <Menu/>
    </div>

    <div class="rwa_kline_page_02">

      <img class="rwa_kline_page_02_bj01" src="../../assets/images/yusbj1.png"/>
      <img class="rwa_kline_page_02_bj02" src="../../assets/images/yusbj2.png"/>

      <div class="rwa_kline_page_021">
        <div class="rwa_kline_page_0211" @click="toHomePage()">
          <img src="../../assets/images/fhjt.png"/>
          {{ lang('home') }}
        </div>

        <div class="rwa_kline_page_0212">

          <div class="rwa_kline_page_02120s">
            <iframe v-if="lpAddress"
                    id="dextools-widget"
                    title="DEXTools Trading Chart"
                    width="100%" height="600"
                    style="border-radius: 12px;"
                    :src="'https://www.dextools.io/widget-chart/en/bnb/pe-light/' + lpAddress + '?theme=dark&chartType=1&chartResolution=30&drawingToolbars=true'">
            </iframe>
            <div v-if="!lpAddress"
                 style="
                 width: 100%;
                 height: 600px;
                 line-height: 600px;
                 text-align: center;
                 color: #FFFFFF;
                 border-radius: 12px;
                 border: 1px solid #595959;
                 background: #252525;">
                {{ lpAddressLoding ? lang('jzz') : lang('zwsj') }}
            </div>
          </div>

          <div class="rwa_kline_page_02123">
            <div class="rwa_kline_page_02123_1">
              <div class="rwa_kline_page_02123_11">
                <img v-if="!tokenLogo" src="../../assets/images/image_yubi.png"/>
                <img v-if="tokenLogo" :src="imgHost + tokenLogo"/>
              </div>

              <div class="rwa_kline_page_02123_12">
                <div class="rwa_kline_page_02123_121">
                  <div class="rwa_kline_page_02123_1211">
                    {{ tokenName ? tokenName : "NULL"  }}
                  </div>
                  <div class="rwa_kline_page_02123_1212">
                    <a v-if="tokenTg" :href="tokenTg" target="_blank"><img src="../../assets/images/huitg.png"/></a>
                    <a v-if="!tokenTg"><img style="cursor: not-allowed" src="../../assets/images/huitg.png"/></a>

                    <a v-if="tokenTt" :href="tokenTt" target="_blank"><img src="../../assets/images/huitt.png"/></a>
                    <a v-if="!tokenTt"><img style="cursor: not-allowed" src="../../assets/images/huitt.png"/></a>

                    <a v-if="tokenWeb" :href="tokenWeb" target="_blank"><img src="../../assets/images/huigw.png"/></a>
                    <a v-if="!tokenWeb"><img style="cursor: not-allowed" src="../../assets/images/huigw.png"/></a>
                  </div>
                </div>

                <div class="rwa_kline_page_02123_122">
                  <div class="rwa_kline_page_02123_1221">
                    Create: {{ cutAccount(tokenAddress, 8) }}
                  </div>
                  <img class="rwa_kline_page_02123_1222" src="../../assets/images/huifz.png" @click="copyValue(tokenAddress)"/>
                </div>
              </div>
            </div>

            <div class="rwa_kline_page_02123_2">
              <div class="rwa_kline_page_02123_21">
                <div class="rwa_kline_page_02123_211">
                  <div class="rwa_kline_page_02123_2111">
                    $ {{tokenLiquidityPool ? tokenLiquidityPool : 'NULL'}}
                  </div>
                  <div class="rwa_kline_page_02123_2112">
                    Liquidity Pool
                  </div>
                </div>

<!--                <div class="rwa_kline_page_02123_211">-->
<!--                  <div class="rwa_kline_page_02123_2111">-->
<!--                    $ {{tokenPrice ? tokenPrice : 0}} BNB-->
<!--                  </div>-->
<!--                  <div class="rwa_kline_page_02123_2112">-->
<!--                    price-->
<!--                  </div>-->
<!--                </div>-->
              </div>

              <div class="rwa_kline_page_02123_21">
                <div class="rwa_kline_page_02123_211">
                  <div class="rwa_kline_page_02123_2111">
                    $ {{tokenMarketCap ? tokenMarketCap : 'NULL'}}
                  </div>
                  <div class="rwa_kline_page_02123_2112">
                    Market Cap
                  </div>
                </div>

<!--                <div class="rwa_kline_page_02123_211">-->
<!--                  <div class="rwa_kline_page_02123_2111">-->
<!--                    $ {{token24HtradingVolume ? token24HtradingVolume : 0}}-->
<!--                  </div>-->
<!--                  <div class="rwa_kline_page_02123_2112">-->
<!--                    24H trading volume-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rwa_kline_page_03">
        <Bottom/>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Bottom from "@/components/Bottom.vue";
import { cutAccount, lang, BigNumberMul } from "@/tools";
import toolUtils, { setDecimal, formatNumberKx, conversionTimestampFormatObj } from "@/tools/toolUtils";
import { mixin1 } from "@/tools/mixins";
import * as metaMaskTools from "@/tools/chain";
import transfer from "@/tools/transfer";
import {
  debug,
  uploadHost
} from "@/config";

export default {
  name: "Kline",
  components: {
    Menu,
    Bottom
  },
  mixins: [mixin1],
  data() {
    return {
      imgHost: uploadHost,
      tokenAddress: null,
      lpAddressLoding: false,
      lpAddress: null,
      tokenLogo: null,
      tokenName: null,
      tokenTg: null,
      tokenTt: null,
      tokenWeb: null,
      tokenPrice: null,
      tokenMarketCap: null,
      tokenLiquidityPool: null,
      token24HtradingVolume: null,
      BNBPrice: 0,
    };
  },
  watch: {},
  created() {
    this.tokenAddress = this.$route.query.tokenAddress;

    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);
  },
  mounted() {
    this.initKlineData();
  },
  destroyed() {
  },
  beforeDestroy() {
  },
  methods: {
    lang(key){
      return lang(key);
    },
    cutAccount(account, num) {
      return cutAccount(account, num);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    copyValue(val) {
      if (val) {
        toolUtils.copyValue(val);
        this.$message.success(lang('fzcg'));
      } else {
        this.$message.error(lang('myfzrhnr'));
      }
    },
    formatNumberKx(num, decimals) {
      return formatNumberKx(num, decimals);
    },
    toTextDate(time) {
      return toolUtils.toTextDate(time);
    },
    getSecondsPassedToday() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      return hours * 3600 + minutes * 60 + seconds;
    },
    /**
     * 返回首页
     */
    toHomePage() {
      transfer.$emit("toMenuPage", 1);
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initKlineData();
    },
    openConnectWallet() {
      this.$store.commit('setState', {
        connectWalletShow: true
      });
    },
    toConnectWalletMining() {
      this.$message.warning(lang('qxljqb'));

      this.openConnectWallet();
    },
    /**
     * 初始化页面数据
     */
    async getInitKlineData() {
      this.tokenAddress = this.$route.query.tokenAddress;
    },
    async getLpAddress() {
      try {
        this.lpAddressLoding = true;

        await metaMaskTools.getLpTokenPoolAddress(this.tokenAddress).then(async (res) => {
          console.log(res);
          if (res) {
            this.lpAddress = res;
          }
        }).catch(async (err) => {
          console.log(err);
        });

        this.lpAddressLoding = false;
      } catch (error) {
        console.log(error);
        this.lpAddressLoding = false;
      }
    },
    async getTokenAllInfo() {
      try {
        if (this.tokenAddress && this.tokenAddress.toLowerCase() !== '0x4e86bfa3376ec576053139d56779f983678f8ba8') {
          await this.$http.getTokenArtlaunch(this.tokenAddress).then(async (res) => {
            console.log(res);
            if (res) {
              this.tokenLogo = res.data.logo;
              this.tokenName = res.data.token_symbol;
              this.tokenTg = res.data.telegram;
              this.tokenTt = res.data.twitter;
              this.tokenWeb = res.data.website;
            }
          }).catch(async (err) => {
            console.log(err);
          });
        } else {
          this.tokenLogo = null;
          this.tokenName = "Bucoin";
          this.tokenTg = null;
          this.tokenTt = null;
          this.tokenWeb = null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getToken24HtradingVolume() {
      try {
        await this.$http.getFetch24hVolume(this.tokenAddress).then(async (res) => {
          console.log(res);
          if (res) {
            this.token24HtradingVolume = res.data.trade_volume_24h;
          }
        }).catch(async (err) => {
          console.log(err);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getBNBPrice() {
      try {
        await metaMaskTools.getBNBPriceFromOracle().then(async (res) => {
          console.log("getBNBPrice: ", res);
          if (res) {
            this.BNBPrice = res;
          }
        }).catch(async (err) => {
          console.log(err);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getTokenPriceLiquidityInfo() {
      try {
        await metaMaskTools.getTokenPriceAndLiquidity(
            this.tokenAddress,
            this.lpAddress,
            this.BNBPrice
        ).then(async (res) => {
          console.log("getTokenPriceAndLiquidity: ", res);
          if (res) {
            this.tokenPrice = res.tokenPrice;
            this.tokenLiquidityPool = res.poolLiquidity
          }
        }).catch(async (err) => {
          console.log(err);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getMarketCapInfo() {
      try {
        await metaMaskTools.getMarketCap(
            this.tokenAddress,
            this.lpAddress,
            this.tokenPrice
        ).then(async (res) => {
          console.log("getMarketCap: ", res);
          if (res) {
            this.tokenMarketCap = this.setDecimal(res, 3);
          }
        }).catch(async (err) => {
          console.log(err);
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 刷新页面数据
     * @returns {Promise<void>}
     */
    async initKlineData() {
      await this.getInitKlineData();
      await this.getLpAddress();
      await this.getTokenAllInfo();
      // await this.getToken24HtradingVolume();
      await this.getBNBPrice();
      await this.getTokenPriceLiquidityInfo();
      await this.getMarketCapInfo();
    },
  },
};
</script>

<style scoped lang="less">
.rwa_kline_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;

  .rwa_kline_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .rwa_kline_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .rwa_kline_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_kline_page_02_bj01 {
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;

      @media (max-width: 767px) {
        display: none;
      }
    }
    .rwa_kline_page_02_bj02 {
      position: absolute;
      top: 0;
      right: 0;
      width: 65%;

      @media (max-width: 767px) {
        width: 100%;
      }
    }
    .rwa_kline_page_02_bj03 {
      display: none;

      @media (max-width: 767px) {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60%;
      }
    }
    .rwa_kline_page_021 {
      position: relative;
      width: 80%;
      margin-left: 10%;
      .rwa_kline_page_0211 {
        width: 150px;
        color: #FFF;
        font-family: Montserrat;
        font-size: 26px;
        font-style: italic;
        font-weight: 900;
        line-height: 152%; /* 39.52px */
        margin: 100px 0 50px 0;
        cursor: pointer;
        img {
          margin-right: 10px;
          margin-bottom: 3px;
        }
      }
      .rwa_kline_page_0212 {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        padding: 20px;
        margin-bottom: 200px;

        border-radius: 12px;
        border: 0.5px solid rgba(153, 153, 153, 0.30);
        background: rgba(49, 49, 49, 0.40);
        box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.10);

        @media (max-width: 767px) {
          padding: 0;
          border-radius: 0;
          border: 0;
          background: 0;
          margin-bottom: 150px;
        }
        .rwa_kline_page_02120s {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          border-radius: 12px;
          margin-bottom: 30px;

          @media (max-width: 767px) {
            flex-direction: column;
            justify-content: flex-start;
          }
        }
        .rwa_kline_page_02123 {
          border-radius: 8px;
          border: 0.5px solid rgba(153, 153, 153, 0.30);
          background: #252525;
          width: 100%;
          margin-bottom: 15px;
          padding: 15px;

          @media (max-width: 767px) {
            width: 100%;
            margin-bottom: 10px;
          }

          .rwa_kline_page_02123_1 {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            .rwa_kline_page_02123_11 {
              margin-right: 12px;
              img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 1px solid rgba(153, 153, 153, 0.30);
                background: linear-gradient(180deg, rgba(81, 81, 81, 0.20) 0%, rgba(81, 81, 81, 0.00) 100%);
              }
            }
            .rwa_kline_page_02123_12 {
              .rwa_kline_page_02123_121 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
                .rwa_kline_page_02123_1211 {
                  color: #D1D5DC;
                  font-family: Inter;
                  font-size: 20px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: normal;
                }
                .rwa_kline_page_02123_1212 {
                  margin-left: 15px;
                  a {
                    img {
                      width: 18px;
                      margin: 0 3px;
                      margin-top: 4px;
                      cursor: pointer;
                    }
                  }
                }
              }
              .rwa_kline_page_02123_122 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: flex-start;
                .rwa_kline_page_02123_1221 {
                  color: #999;
                  font-family: Inter;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 19px; /* 158.333% */
                }
                .rwa_kline_page_02123_1222 {
                  width: 15px;
                  cursor: pointer;
                  margin-left: 10px;
                  margin-bottom: 2px;
                }
              }
            }
          }

          .rwa_kline_page_02123_2 {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 20px;
            .rwa_kline_page_02123_21 {
              display: flex;
              flex-direction: column;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: flex-start;

              width: calc(50% - 8px);
              height: 68px;
              .rwa_kline_page_02123_211 {
                display: flex;
                width: 100%;
                height: 58px;
                padding: 10px;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                border-radius: 10px;
                border: 1px solid rgba(153, 153, 153, 0.30);
                background: #272727;
                .rwa_kline_page_02123_2111 {
                  color: #D1D5DC;
                  font-family: Inter;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 800;
                  line-height: 19px; /* 135.714% */
                }
                .rwa_kline_page_02123_2112 {
                  color: #999;
                  font-family: Inter;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 19px; /* 158.333% */
                }
              }
            }
          }
        }
      }
    }
    .rwa_kline_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_kline_div {
  .el-input-number {
    width: 100%;
  }
  .el-input-number__increase {
    background: #363636;
    line-height: 19px !important;
    border-left: 1px solid #616161 !important;
    border-bottom: 1px solid #616161 !important;
  }
  .el-input-number__decrease {
    background: #363636;
    line-height: 19px !important;
    border-left: 1px solid #616161 !important;
  }

  .el-input-number__increase {
    border-left: 1px solid #20944B !important;
    border-bottom: 1px solid #20944B !important;
  }
  .el-input-number__decrease {
    border-left: 1px solid #20944B !important;
  }

  .el-input-number__decrease, .el-input-number__increase {
    color: #cbcbcb !important;
  }

  .el-input__inner {
    color: #c8cbd2 !important;
    background-color: rgba(0, 201, 80, 0.05) !important;
    border: 1px solid #20944B !important;
  }
  .el-input-number__increase.is-disabled, .el-input-number__decrease.is-disabled {
    color: #606266;
  }

  .el-progress-bar {
    border-radius: 10px !important;
    border: 1px solid #20944B !important;

    @media (max-width: 767px) {
      border-radius: 11px !important;
    }
  }
  .el-progress-bar__inner {
    background: linear-gradient( 90deg, #0A2E17 0%, #20944B 100%) !important;
  }
}
</style>